import { classifyImage } from "../services/api/editor/classify";
import { formatClassifyLabel } from "./formatClassifyLabel";

const FALLBACK_LABELS = new Set(["object", "upload", "image", ""]);

export function isFallbackClassifyLabel(label) {
  const s = String(label || "").trim().toLowerCase();
  if (FALLBACK_LABELS.has(s)) return true;
  // Legacy UI placeholders: Upload.webp, Upload.jpeg, Upload 123
  if (s.startsWith("upload.") || s.startsWith("upload ")) return true;
  return false;
}

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

/**
 * Classify with retries — first request often fails while PhotoStudio loads ONNX.
 * @returns {Promise<string|null>} Display label, or null if classify unavailable
 */
export async function classifyImageLabelWithRetry(
  token,
  imageFile,
  { attempts = 4, topK } = {}
) {
  if (!token || !imageFile) return null;

  for (let i = 0; i < attempts; i++) {
    try {
      const data = await classifyImage(token, imageFile, { topK });
      if (
        data?.success &&
        data.label &&
        !isFallbackClassifyLabel(data.label)
      ) {
        return formatClassifyLabel(data.label);
      }
    } catch {
      /* retry */
    }
    if (i < attempts - 1) {
      await sleep(600 * (i + 1));
    }
  }
  return null;
}
